import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { LogoutContainer } from "../components/Logout/LogoutContainer";

export type Props = {
  onSuccess: () => void;
  redirectTo?: string;
};

export function LogoutPage({ onSuccess, redirectTo = "/login" }: Props) {
  const navigate = useNavigate();

  const handleSuccess = () => {
    startTransition(() => {
      onSuccess();

      navigate(redirectTo);
    });
  };

  const onError = () => {
    navigate(redirectTo);
  };

  return (
    <div className="flex-1 flex flex-col justify-between bg-brand-50 text-brand-800">
      <LogoutContainer onSuccess={handleSuccess} onError={onError} />
    </div>
  );
}

export default LogoutPage;
